import { styled } from '@linaria/react';

export default styled.div`
  margin-bottom: ${props => (props.isLastElement ? '0' : '20px')};
  width: 100%;
`;
